import { Injectable, Inject, Optional } from "@angular/core";

import { OrderByPipe, FilterByPipe } from "ngx-pipes";

import { Table } from "./classes/table";

import { TableSettings, TableColumnData } from "./table.interface";

@Injectable()
export class TableService {
  constructor(
    @Optional() @Inject(OrderByPipe) private orderBy: OrderByPipe,
    @Optional() @Inject(FilterByPipe) private filterBy: FilterByPipe
  ) {}

  public columns: { [key: string]: TableColumnData } = {};

  public create(table_settings: TableSettings) {
    return new Table(table_settings, this.orderBy, this.filterBy);
  }

  public getColumn(
    column_name: string,
    overwrite_data: Partial<TableColumnData> = {}
  ): TableColumnData | null {
    if (!this.columns[column_name]) return null;

    return {
      ...this.columns[column_name],
      ...overwrite_data
    };
  }

  public addColumn(column_name: string, column_data: TableColumnData) {
    this.columns[column_name] = column_data;
  }

  public removeColumn(column_name: string) {
    delete this.columns[column_name];
  }

  public registerColumns(columns: { [key: string]: TableColumnData }) {
    this.columns = {
      ...this.columns,
      ...columns
    };
  }
}
